module.exports = __webpack_public_path__ + "static/img/Dane_Rampe_desktop.3589cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dane_Rampe_desktop.jpg
// module id = qVzT
// module chunks = 0